import { groupBy, isEmpty } from 'lodash'

import { formattedDateByTimeZone } from 'utils/timezone'

export const getGroupedOrdersByDate = (orders) =>
  groupBy(
    orders?.map(
      ({ state, displayState, reason, stateTransitionTime, id, createdAt }) => {
        if (isEmpty(stateTransitionTime) && isEmpty(createdAt)) {
          return {
            state: state ?? '',
            dateAndTime: 'N/A',
            reason: reason ?? '',
            displayState: displayState ?? '',
            id,
            orderDate: 'N/A',
          }
        }

        const { time, dateWithSlashes, dayAndMonth, year } =
          formattedDateByTimeZone(stateTransitionTime ?? createdAt)
        const orderDate = `${dayAndMonth}, ${year}`

        return {
          state: state ?? '',
          dateAndTime: `${dateWithSlashes}, ${time}`,
          reason: reason ?? '',
          displayState: displayState ?? '',
          id,
          orderDate,
        }
      }
    ),
    'orderDate'
  ) ?? {}
